import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IContentItem } from '../interfaces/content-item';
import { CONTENT_API_TOKEN, LEGACY_CONTENT_API_TOKEN } from '../tokens';

/** Content service */
@Injectable()
export class ContentApiService {
  /** Dependencies */
  constructor(
    @Inject(CONTENT_API_TOKEN) private apiUrl: string,
    @Inject(LEGACY_CONTENT_API_TOKEN) private legacyApiUrl: string,
    private http: HttpClient,
  ) {}

  /** Method to get content by id */
  public fetch(id: string): Observable<IContentItem> {
    return this.http.get<IContentItem>(`${this.apiUrl}/${id}`);
  }

  public putPersonal(file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.put<
      ReadonlyArray<{
        cdnUrl: string;
        url: string;
        contentType: string;
        name: string;
      }>
    >(`${this.legacyApiUrl}/static/personal`, formData);
  }
}
